import _, { isEmpty } from 'lodash';
import { ANGLED_TEXT_AXIS_LABEL_PADDING } from '../../../common';
import { isDashletMode } from '../../../auth';

export const doesPointDataHaveMissingValue = ({ focusedData, pointData }) => {
  if (isEmpty(pointData)) {
    return false;
  }

  const focusedDataLines = focusedData.map(({ lines }) => lines[0]);

  return pointData
    .filter(
      ({ pathInfo: { lines } }) =>
        isEmpty(focusedData) || focusedDataLines.includes(lines[0]),
    )
    .every(({ y }) => y === '-' || y === 0);
};

export const selectFDProps = _focusedDataPoints =>
  _.join(
    _.flatMap(_focusedDataPoints, _point =>
      _.map(
        ['posX', 'posY', 'xAxis'],
        prop => `${prop}:${_.get(_point, prop)}`,
      ).join(','),
    ),
    ';',
  );

export const getXAxisHeight = ({
  shouldRotateAxisLabels,
  defaultXAxisHeight,
}) => {
  return shouldRotateAxisLabels
    ? defaultXAxisHeight + ANGLED_TEXT_AXIS_LABEL_PADDING
    : defaultXAxisHeight;
};

export const getPreferredHeight = ({
  shouldRotateAxisLabels,
  hideAxis,
  height,
  defaultXAxisHeight,
}) => {
  if (!shouldRotateAxisLabels || hideAxis) {
    return height;
  }
  const correction = isDashletMode()
    ? ANGLED_TEXT_AXIS_LABEL_PADDING
    : ANGLED_TEXT_AXIS_LABEL_PADDING / 2;

  return (
    height -
    (getXAxisHeight({
      shouldRotateAxisLabels,
      defaultXAxisHeight,
    }) -
      correction)
  );
};
